<script>
import Swal from "sweetalert2";

// Custom Components
import GuestService from "@/helpers/APIService/guest.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  components: {},
  props: {
    currentProps: Object,
  },
  emits: ["submitted"],
  data() {
    return {
      cardNumber: "",
      cardExpiry: "",
      cardCvv: "",
      cardHolder: "",
      cardErrors: {},
      cardErrorMessage: "",
      viewCardDetails: true,
      addNewCardFormOpen: false,
      isError: false,
      is_Edit_Error: false,
      isBtnLoading: false,
      isDataLoading: true,
      tableOfCards: {
        tableData: [],
      },
    };
  },
  watch: {
    // handle auto-focus to next field
    cardNumber: function (val) {
      if (this.$cardFormat.validateCardNumber(val)) {
        this.$refs.cardExpInput.focus();
      }
    },
    cardExpiry: function (val) {
      if (this.$cardFormat.validateCardExpiry(val)) {
        this.$refs.cardCvcInput.focus();
      }
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getCards();
  },
  methods: {
    getCards() {
      this.isDataLoading = true;
      GuestService.getCard(this.currentProps.guest_id.id)
        .then((response) => {
          let records = [];
          response.map((item) => {
            records.push({
              expiry_time: `${
                item.exp_month !== null || "" ? item.exp_month + "/" : ""
              }${(item.exp_year !== null) | "" ? item.exp_year : ""}`,
              card_brand: item.card_brand,
              last_digit: item.last_digit !== null || "" ? item.last_digit : "",
              is_default: item.is_default,
              card_holder_name:
                item.card_holder_name !== null || ""
                  ? item.card_holder_name
                  : "",
              country: item.country,
              created_at: item.created_at,
              created_by: item.created_by,
              cvv: item.cvv,
              exp_month: item.exp_month !== null || "" ? item.exp_month : "",
              exp_year: item.exp_year !== null || "" ? item.exp_year : "",
              funding: item.funding,
              guest: item.guest,
              id: item.id,
              payment_gateway_type: item.payment_gateway_type,
              three_d_secure_usage_supported:
                item.three_d_secure_usage_supported,
              updated_at: item.updated_at,
              updated_by: item.updated_by,
            });
          });
          this.isDataLoading = false;
          this.tableOfCards.tableData = records;
        })
        .catch((err) => {
          const response = errorHandler(err);
          if (response === 401) {
            this.getCards();
          }
        });
      this.cardHolder = this.currentProps.guest_id.name;
    },
    cardViewModal(id) {
      this.guestId = id;
      this.cardViewModalOpen = !this.cardViewModalOpen;
      this.getCards();
    },
    validate() {
      this.cardErrors = {};
      // Validate card holder name
      if (this.cardHolder === null || "") {
        this.cardErrors.cardHolder = "Please Add Card Holder Name.";
      }
      // validate card number
      if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
        this.cardErrors.cardNumber = "Invalid Credit Card Number.";
      }

      // validate card expiry
      if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
        this.cardErrors.cardExpiry = "Invalid Expiration Date.";
      }

      // validate card CVC
      if (!this.$cardFormat.validateCardCVC(this.cardCvv)) {
        this.cardErrors.cardCvv = "Invalid CVV.";
      }
      if (Object.keys(this.cardErrors).length !== 0) {
        return false;
      } else {
        return true;
      }
    },
    addNewCard() {
      this.isBtnLoading = true;
      const validation = this.validate();
      if (validation) {
        const expiryDate = this.cardExpiry.split("/");
        let year = expiryDate[1].trim();
        let month = expiryDate[0].trim();
        if (this.hotel.is_payment_gateway) {
          const data = {
            guest: this.currentProps.guest_id.id,
            payment_gateway_type: "macrotech",
            card_holder_name: this.cardHolder,
            card_number: this.cardNumber,
            exp_month: month,
            exp_year: year,
            cvv: this.cardCvv,
            is_add_card: true,
          };
          GuestService.addCard(this.currentProps.guest_id.id, data)
            .then((response) => {
              Middleware.notification("Successfully added !!", "success", 3000);
              this.add_new_card = false;
              this.tableOfCards.tableData.push(response);
              this.cardNumber = "";
              this.cardExpiry = "";
              this.cardCvv = "";
              this.getCards();
              this.isBtnLoading = false;
            })
            .catch((err) => {
              this.isBtnLoading = false;
              this.isError = true;
              if (err.response.status === 500) {
                this.cardErrorMessage =
                  "Internal Server Error : Something went wrong";
              } else {
                this.cardErrorMessage = err.response.data.message;
              }
              console.log(err.response);
            });
        } else {
          this.cardNumber = "";
          this.cardExpiry = "";
          this.cardCvv = "";
          this.isBtnLoading = false;
          return Middleware.notification(
            "Payment gateway is not connected !!",
            "warning",
            3000
          );
        }
      }
    },
    onMounted() {
      this.$refs.cardNumInput.focus();
    },
    changeCardStatus(data) {
      this.tableOfCards.tableData.map((card) => {
        if (card.id === data.id) {
          card.is_default = true;
          GuestService.editCard(this.currentProps.guest_id.id, data.id, {
            is_default: data.is_default,
          })
            .then(() => {
              Middleware.notification(
                "Status changed successfully !!",
                "success",
                3000
              );
              this.getCards();
            })
            .catch((err) => {
              const response = errorHandler(err);
              if (response === 401) {
                this.changeCardStatus();
              }
              this.is_Edit_Error = true;
            });
        } else {
          card.is_default = false;
        }
      });
    },
    deleteCard(id) {
      if (this.tableOfCards.tableData.length === 1) {
        Middleware.notification("You can't delete last card !!", "info", 3000);
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.value) {
            GuestService.deleteCard(this.currentProps.guest_id.id, id)
              .then(() => {
                let index = this.tableOfCards.tableData.findIndex(
                  (el) => el.id === id
                );
                this.tableOfCards.tableData.splice(index, 1);
                if (this.tableOfCards.tableData.length === 1) {
                  this.tableOfCards.tableData.map((item) => {
                    this.changeCardStatus({ id: item.id, is_default: true });
                  });
                }
                Middleware.notification(
                  "Successfully deleted !!",
                  "danger",
                  3000
                );
              })
              .catch((err) => {
                const response = errorHandler(err);
                if (response === 401) {
                  this.deleteCard();
                }
              });
          }
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="offcanvas-header py-0">
      <h4 class="offcanvas-title" id="offcanvasExampleLabel">Card Details</h4>
    </div>
    <div class="offcanvas-body">
      <b-card no-body class="shadow-none">
        <b-card-header
          header-tag="header"
          role="tab"
          v-b-toggle.viewCardDetails
        >
          <h6 class="my-1" slot="header">View list of card</h6>
        </b-card-header>
        <b-collapse
          id="viewCardDetails"
          :visible="viewCardDetails"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <div class="mb-0">
                <div class="table-responsive mb-0">
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getCards"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Card</th>
                        <th>Card#</th>
                        <th>Validity</th>
                        <th>Default</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody
                      id="infinite-list"
                      v-if="tableOfCards.tableData.length > 0 && !isDataLoading"
                    >
                      <tr
                        v-for="(data, index) in tableOfCards.tableData"
                        :key="index"
                      >
                        <td>
                          <i
                            class="fab fa-cc-visa fa-2x"
                            v-if="data.card_brand === 'visa'"
                          ></i>
                          <i class="fab fa-cc-mastercard fa-2x" v-else></i>
                        </td>
                        <td>
                          {{
                            data.last_digit !== null || ""
                              ? data.last_digit
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            data.expiry_time !== null || ""
                              ? data.expiry_time
                              : ""
                          }}
                        </td>

                        <td>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="data.is_default"
                            @change="
                              changeCardStatus({
                                id: data.id,
                                is_default: data.is_default,
                              })
                            "
                          />
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <i
                              class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                              v-b-popover.hover="'Delete recored'"
                              id="delete"
                              @click="deleteCard(data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="isDataLoading">
                      <tr>
                        <td class="placeholder-glow" v-for="no in 5" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-if="
                        !isDataLoading && tableOfCards.tableData.length == 0
                      "
                    >
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="shadow-none">
        <b-card-header
          header-tag="header"
          role="tab"
          v-b-toggle.addNewCardFormOpen
        >
          <h6 class="my-1" slot="header">Add new card</h6>
        </b-card-header>
        <b-collapse
          id="addNewCardFormOpen"
          :visible="addNewCardFormOpen"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <form ref="form">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <b-form-input
                        id="first-last-input"
                        type="text"
                        autocomplete="off"
                        placeholder="Card holder name"
                        v-model="cardHolder"
                      ></b-form-input>
                    </div>
                    <div v-if="cardErrors.cardHolder" class="error">
                      <small>{{ cardErrors.cardHolder }}</small>
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <b-form-input
                        ref="cardNumInput"
                        id="first-last-input"
                        v-cardformat:formatCardNumber
                        placeholder="XXXX XXXX XXXX XXXX"
                        v-model="cardNumber"
                        :data-error="cardErrors.cardNumber ? true : false"
                        @change="
                          () => {
                            isError = false;
                            isBtnLoading = false;
                          }
                        "
                      ></b-form-input>
                    </div>
                    <div v-if="cardErrors.cardNumber" class="error">
                      <small>{{ cardErrors.cardNumber }}</small>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group">
                      <b-form-input
                        ref="cardExpInput"
                        id="first-last-input"
                        v-cardformat:formatCardExpiry
                        placeholder="MM / YYYY"
                        v-model="cardExpiry"
                        :data-error="cardErrors.cardExpiry ? true : false"
                      ></b-form-input>
                    </div>
                    <div v-if="cardErrors.cardExpiry" class="error">
                      <small>{{ cardErrors.cardExpiry }}</small>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group">
                      <b-form-input
                        ref="cardCvcInput"
                        id="first-last-input"
                        v-cardformat:formatCardCVC
                        placeholder="CVV"
                        v-model="cardCvv"
                        :data-error="cardErrors.cardCvv ? true : false"
                      ></b-form-input>
                    </div>
                    <div v-if="cardErrors.cardCvv" class="error">
                      <small>{{ cardErrors.cardCvv }}</small>
                    </div>
                  </div>
                </div>
                <div v-if="isError">
                  <b-alert v-if="isError" show variant="danger">
                    <p>{{ cardErrorMessage }}</p>
                  </b-alert>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button
                      class="btn btn-primary float-end"
                      type="button"
                      @click="addNewCard"
                      :class="{ disabled: isBtnLoading }"
                    >
                      <i
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        v-if="isBtnLoading"
                      ></i>
                      Add New Card
                    </button>
                  </div>
                </div>
              </form>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
